<div class="self-signup-container">
  <div class="v-pattern v-pattern-left" aria-hidden="true"></div>
  <div class="v-pattern v-pattern-right" aria-hidden="true"></div>

  <div class="fixed-top-section">
    <img alt="Vendasta" src="../assets/images/sign-up/vendasta-logo-white-green.svg" width="134" height="20" />
  </div>

  <div class="self-signup-content">
    <app-sign-up-form-v2 class="signup-redesign" [loginURL]="loginURL"></app-sign-up-form-v2>
  </div>

  <footer class="signup-footer">
    <div class="signup-footer-inner">
      <div class="signup-footer-links">
        <span class="signup-footer-copyright">
          {{ 'SIGNUP.FOOTER.COPYRIGHT' | translate: { year: currentYear } }}
        </span>
        <a href="https://www.vendasta.com/sitemap/" target="_blank">{{ 'SIGNUP.FOOTER.SITEMAP' | translate }}</a>
        <a href="https://www.vendasta.com/terms/terms-of-service/" target="_blank">
          {{ 'SIGNUP.FOOTER.TERMS' | translate }}
        </a>
        <a href="https://www.vendasta.com/privacy-policy" target="_blank">{{ 'SIGNUP.FOOTER.PRIVACY' | translate }}</a>
        <a href="https://www.vendasta.com/gdpr/" target="_blank">{{ 'SIGNUP.FOOTER.GDPR' | translate }}</a>
      </div>
      <div class="signup-footer-badges">
        <img src="../assets/images/sign-up/amazon-ads-badge.png" alt="Amazon Ads Verified Partner" height="42" />
        <img src="../assets/images/sign-up/bbb-seal.webp" alt="BBB Accredited Business" height="42" />
        <img src="../assets/images/sign-up/soc2-seal.webp" alt="AICPA SOC 2 certified" height="42" />
        <img src="../assets/images/sign-up/gdpr-seal.svg" alt="EU GDPR compliant" height="42" />
      </div>
    </div>
  </footer>
</div>
